import { baseApi } from './base.api';
import { listenerMiddleware } from './listener.middleware';
import { storeManager } from './store.manager.instance';

/**
 * Opt a feature into the shared RTK store infrastructure: wires the listener middleware and the RTK Query api
 * (reducer + middleware) into the store. Call it once from a feature's store bootstrap, before it registers
 * listeners or dispatches queries; idempotent across features, so the first RTKQ feature to load wires it.
 *
 * Keeps RTK/RTKQ/immer off the eager boot bundle: this module — and the RTK it imports — is pulled in only
 * when a feature that calls it loads. Listener first so its dispatched cache actions reach the api middleware.
 */
export function enableSharedRtk() {
    storeManager.addMiddleware(listenerMiddleware.middleware);
    storeManager.enableApi(baseApi);
}
